import {layoutActions} from 'features/layout/redux';
import LoginDialog from 'features/login/LoginDialog';
import React from 'react';
import {useDispatch} from 'react-redux';
import SankeyChart from './SankeyChart';

export const SankeyPage = () => {
   // const isAuthenticated = useSelector(loginSelectors.isAuthenticated);

   const dispatch = useDispatch();
   React.useEffect(() => {
      dispatch(layoutActions.loadTreeNav());
   }, [dispatch]);

   // useEffect(fetchData, [fetchData, isAuthenticated]);

   return (
      <>
         <SankeyChart />
         <LoginDialog />
      </>
   );

   // return state ? <Sankey width={700} height={400} data={state} /> : null;
};
